import { ArchivoAcreditadoService } from './src/services/archivo.acreditado.service';
export const archivoAcreditadoService = new ArchivoAcreditadoService();
export default archivoAcreditadoService;
